import { render, staticRenderFns } from "./IgnoreHeaderConfigModal.vue?vue&type=template&id=16ac5ee1&scoped=true"
import script from "./IgnoreHeaderConfigModal.vue?vue&type=script&lang=js"
export * from "./IgnoreHeaderConfigModal.vue?vue&type=script&lang=js"
import style0 from "./IgnoreHeaderConfigModal.vue?vue&type=style&index=0&id=16ac5ee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac5ee1",
  null
  
)

export default component.exports